/* eslint-disable import/no-cycle */
import { get, map } from 'lodash'

// types
import { IResponsePagination } from '../../types/interfaces'

import { ThunkResult } from '../index'
import { USERS } from './userTypes'
import { IResetStore } from '../generalTypes'

// utils
import { formatDateWithTimeDdMmYyyy, formatDateWithTimeHhMM, normalizeQueryParams } from '../../utils/helper'

import { getReq } from '../../utils/request'
import { PAGINATION, PERMISSION } from '../../utils/enums'
import { AuthUser } from '../authorization/authActions'

export type IUserActions = IResetStore | IGetUsersActions

// user
export interface IUserPayload {
	data: AuthUser | null
	isLoading: boolean
	isFailure: boolean
}

export interface IUserPermissions {
	id: number
	key: number
	userID: number
	name: string
	permissions: UserPermission[]
}

// users
interface IGetUsersActions {
	type: USERS
	payload: IUsersPayload
}

type UsersOriginalItem = {
	key: number
	id: number
	firstName: string
	lastName: string
	lastLoginAt: string
	email: string
	role: string
}

export type UsersTableItem = {
	key: number
	id: number
	firstName: string
	lastName: string
	lastLoginAtDate: string
	lastLoginAtHours: string
	email: string
	role: string
}

export interface IUsersPayload {
	tableData: UsersTableItem[]
	originalData: UsersOriginalItem[]
	pagination: IResponsePagination | null
}

export type UserPermission = {
	displayName: string
	id: number
	key: PERMISSION
	roles: {}[]
}

export type RolesType = {
	id: number
	name: string
	permissions: UserPermission[]
}

export type User = {
	id: number
	name: string | null
	surname: string | null
	email: string
	confirmedAt: string | null
	lastLoginAt: string | null
	roles: RolesType[]
	permissions: UserPermission[]
	creator: {
		id: number
		initials: string
		fullName: string | null
	}
	createdAt: string
	destructor: {
		id: number
		fullName: string
	} | null
	deletedAt: string | null
	ipAddresses: {
		id: number
		ip: string
	}[]
}

export const getUsers =
	(page = 1, limit?: number | null, queryParams = {}): ThunkResult<Promise<any>> =>
	async (dispatch) => {
		try {
			dispatch({ type: USERS.USERS_LOAD_START })
			const pageLimit = limit || PAGINATION.limit

			const { data } = await getReq('/api/admin/users', { page, limit: pageLimit, ...normalizeQueryParams(queryParams) })
			const originalData = get(data, 'data.users', [])
			const tableData: any[] = map(originalData, (column) => ({
				key: column.uid,
				id: column.uid,
				firstName: column.firstName,
				lastName: column.lastName,
				lastLoginAtDate: formatDateWithTimeDdMmYyyy(column.lastLoginAt) || '-',
				lastLoginAtHours: formatDateWithTimeHhMM(column.lastLoginAt) || '-',
				email: column.email || '-',
				role: column.role
			}))

			const payload: IUsersPayload = {
				tableData,
				originalData,
				pagination: get(data, 'pagination')
			}

			dispatch({ type: USERS.USERS_LOAD_DONE, payload })
			return payload
		} catch (e) {
			dispatch({ type: USERS.USERS_LOAD_FAIL })
			return e
		}
	}
